import { PayloadAction } from '@reduxjs/toolkit';

import { PanAndZoomState } from 'editor/src/store/editorModules/panAndZoom/types';

const setDefaultZoomReducer = (state: PanAndZoomState, action: PayloadAction<number | undefined>) => {
  state.defaultZoom = action.payload;
};

export default setDefaultZoomReducer;
